import { renderToStaticMarkup } from 'react-dom/server';
import { styled } from 'styled-components';

import { ForaBackground } from '../../../assets/backgrounds';
import { Container } from '../../Layout';
import { useMediaMin } from '../../Media';
import { theme } from '../../../styles';

type LoginLayoutProps = {
  children: JSX.Element;
};

const LoginLayoutContainer = styled(Container)<{
  backgroundImage: string;
  children: JSX.Element;
}>`
  ${props => `background-image: url("data:image/svg+xml,${props.backgroundImage}")`};
  height: 100vh;
  min-height: 100%;
  background-position: center;
  background-size: cover;
`;

export const LoginLayout = ({ children }: LoginLayoutProps) => {
  const encodedForaBackground = encodeURIComponent(renderToStaticMarkup(<ForaBackground />));
  return (
    <LoginLayoutContainer backgroundColor="foraBlue" backgroundImage={encodedForaBackground}>
      {children}
    </LoginLayoutContainer>
  );
};

export const LoginSidePanel = ({ children }: { children: React.ReactNode }) => {
  const isDesktop = useMediaMin(theme.breakpoint.lg);
  return (
    <Container
      width={isDesktop ? 640 : 'auto'}
      height="100%"
      backgroundColor={isDesktop ? 'white' : 'darkBlue'}
      paddingTop={[40, 60, 80]}
      paddingRight={[20, 104, 80]}
      paddingBottom={[40, 60, 80]}
      paddingLeft={[20, 104, 80]}
    >
      {children}
    </Container>
  );
};
